import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

export const TourDetailsPageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const TourDetailsTabContent = styled(Paper)(({ theme }) => ({
  height: 'calc(100vh - 210px)',
  minHeight: theme.spacing(34.5),
  overflow: 'auto',
  padding: theme.spacing(3),
  position: 'relative',
}));
